// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.opt[data-v-64a51b3e] {\n  display: flex;\n  justify-content: space-around;\n&[data-v-64a51b3e] .el-button {\n      padding: 0;\n}\n}\n.tips[data-v-64a51b3e] {\n    width: 100%;\n    text-align: right;\n    height: 16px;\n    font-size: 12px;\n    font-family: Microsoft YaHei-Regular, Microsoft YaHei;\n    font-weight: 400;\n    color: #CDCDCD;\n    line-height: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
